import apiClient from '../../../services/apiClient/apiClient';
import { MenuStatus } from "../components/MenuDumpModal";
import { useMutation } from "react-query";

const pollReportUrl = async (url: string) => {
  try {
    const response = await fetch(url, { method: 'HEAD' });
    return response.status === 200;
  } catch (error) {
    return false;
  }
};

const unicodeDecoded = (url: string) => {
  return url.replace(
      /\\u[\dA-F]{4}/gi,
      (match) =>
          String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16))
  );
}

interface MenuDumpProps {
  franchiseCode: string;
  menuStatus: MenuStatus;
}

export const useMenuDump = () => {
  return useMutation<string, Error, MenuDumpProps>(({franchiseCode, menuStatus}: MenuDumpProps) =>
      apiClient.post('/menu-dump', {
        franchiseCode,
        active: menuStatus === MenuStatus.ACTIVE
      })
      .then(async ({ data: responseData }) => {
        // If the response has a body field (raw lambda response), parse it
        if (responseData.body && typeof responseData.body === 'string') {
          responseData = JSON.parse(responseData.body);
        }

        let { downloadUrl, pollingUrl }: {downloadUrl: string, pollingUrl: string} = responseData;

        // Decode Unicode escape sequences in both URLs
        if (downloadUrl) {
          downloadUrl = unicodeDecoded(downloadUrl);
        }

        if (pollingUrl) {
          pollingUrl = unicodeDecoded(pollingUrl);
        }

        return await new Promise<string>((resolve, reject) => {
          const intervalId = setInterval(async () => {
            // Use Polling URL for HEAD requests to check file status. Resolve if available
            if (await pollReportUrl(pollingUrl)) {
              clearInterval(intervalId);
              resolve(downloadUrl);
            }
          }, 3000);

          // Timeout after 15 minutes -- max lambda timeout
          setTimeout(() => {
            clearInterval(intervalId);
            reject("Report generation timed out.")
          }, 900000);
        })
      })
  )
};
